// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#email-confirmation-page-container,#email-verification-sent-page-container,#incorrect-email-confirmation-page-container{height:100%;text-align:center}", ""]);
// Exports
module.exports = exports;
